module.exports = __webpack_public_path__ + "img/fail.d01dca9a.png";